import { SocketContext } from "lib/socket";
import { useContext } from "react";

export const useSocket = () => {
  const value = useContext(SocketContext);

  return value;
};
